import React from 'react'

interface WaveDividerProps {
  position?: 'top' | 'bottom'
  color?: string
  className?: string
  inverted?: boolean
}

const WaveDivider: React.FC<WaveDividerProps> = ({
  position = 'bottom',
  color = '#FFFFFF',
  className = '',
  inverted = false,
}) => {
  const transform =
    position === 'top'
      ? inverted
        ? 'rotate(180deg) scaleX(-1)'
        : 'rotate(180deg)'
      : inverted
        ? 'scaleX(-1)'
        : ''

  return (
    <div
      className={`absolute left-0 w-full overflow-hidden leading-[0] ${
        position === 'top' ? 'top-[-1px]' : 'bottom-[-1px]'
      } ${className}`}
      style={{ transform, zIndex: 10 }}
    >
      <svg
        className="block relative w-[calc(100%+1.3px)] h-[60px] md:h-[120px]"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        preserveAspectRatio="none"
      >
        <path
          fill={color}
          fillOpacity="0.3"
          d="M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,218.7C672,235,768,245,864,234.7C960,224,1056,192,1152,186.7C1248,181,1344,203,1392,213.3L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        ></path>
        <path
          fill={color}
          fillOpacity="0.6"
          d="M0,160L48,170.7C96,181,192,203,288,192C384,181,480,139,576,133.3C672,128,768,160,864,186.7C960,213,1056,235,1152,224C1248,213,1344,171,1392,149.3L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        ></path>
        <path
          fill={color}
          fillOpacity="1"
          d="M0,96L48,112C96,128,192,160,288,165.3C384,171,480,149,576,128C672,107,768,85,864,96C960,107,1056,149,1152,165.3C1248,181,1344,171,1392,165.3L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        ></path>
      </svg>
    </div>
  )
}

export default WaveDivider
